import styles from './CompanyLoginMessage.module.css';

export default function CompanyLoginMessage({
  loginMessage,
}: {
  loginMessage: string | null;
}) {
  if (!loginMessage) return null;

  return (
    <div className={styles.container}>
      <div className={styles.message}>{loginMessage}</div>
    </div>
  );
}
